<template>
  <v-app class="app-bg">
    <navigation v-if="showMenu" />
    <v-main
      class="content-view"
      :style="
        showMenu && $vuetify.breakpoint.xs && $route.name === 'need-map'
          ? 'padding-top:56px;'
          : showMenu &&
            $vuetify.breakpoint.xs &&
            $route.name !== 'mobile-chat-room'
          ? 'padding-top:70px; padding-bottom: 56px'
          : showMenu
          ? 'padding-top:56px;'
          : ''
      "
    >
      <router-view />
      <div
        v-if="
          profile &&
            profile.type === 'Volunteer' &&
            ifTracking &&
            (!timerInfo || timerInfo.status !== 'Completed')
        "
      >
        <div class="volunteer-tracker">
          <!-- Main Floating Widget -->
          <div class="tracker-widget" @click="onFabClick">
            <div class="tracker-pulse"></div>
            <v-btn
              fab
              dark
              large
              class="tracker-btn"
              color="#2BB066"
              elevation="6"
              @click="onFabClick"
            >
              <v-icon x-large>mdi-hand-heart-outline</v-icon>
            </v-btn>

            <div class="tracker-info">
              <div class="tracker-header">
                <v-icon small color="#2BB066" class="mr-1"
                  >mdi-clock-outline</v-icon
                >
                <span class="tracker-title">Active Need</span>
              </div>
              <div class="tracker-time">
                {{ formatSeconds() }}
              </div>
              <div class="tracker-subtext">
                {{ profile.first_name + " " + profile.last_name }}
              </div>
            </div>
          </div>

          <!-- Optional: Progress Indicator (uncomment if needed) -->
          <!-- <div class="tracker-progress">
      <v-progress-circular
        :value="(timerSeconds % 60) * 1.666"
        color="#2BB066"
        size="48"
        width="3"
      >
        <v-icon small color="#2BB066">mdi-heart</v-icon>
      </v-progress-circular>
    </div> -->
        </div>
      </div>
    </v-main>
    <notifications group="message" position="bottom left" />
    <bottom-navigation
      v-if="showMenu && $route.name !== 'mobile-chat-room'"
      class="hidden-sm-and-up"
    />
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import dateFormat from "dateformat";
import Navigation from "./components/Navigation.vue";
import BottomNavigation from "./components/BottomNavigation.vue";

export default {
  name: "App",
  metaInfo: {
    title: "Default Title",
    titleTemplate: "%s | My Awesome Webapp"
  },
  components: {
    Navigation,
    BottomNavigation
  },

  data() {
    return {
      showMenu: false,
      ifTracking: false,
      needId: null,
      timerSeconds: 0,
      running: false,
      timeslot: null,
      memo: "",
      shift: null,
      responses: [],
      loading: false,
      snackbar: false,
      snackMessage: "",
      today: null,
      startDateStr: "",
      shiftHours: 0,
      timeSlot: null
    };
  },
  methods: {
    ...mapActions({
      findTimer: "timeslot/findTimer",
      getTimeTracking: "timeslot/getTimeTracking"
    }),
    startCounting() {
      if (this.running) {
        this.running = false;
      } else {
        this.running = true;
        this.plusSecond();
      }
    },
    plusSecond() {
      if (this.running) {
        //console.log("plusSecond called", this.timerSeconds);
        this.timerSeconds++;
        // if not timerinfo, return
        if (!this.timerInfo) return;
        // Check if timer should auto-stop based on shiftHours
        if (
          console.log("timerInfo shiftHours", this.timerInfo.shiftHours),
          this.timerInfo.shiftHours > 0 &&
            this.timerSeconds >= this.timerInfo.shiftHours * 60 * 60
        ) {
          // Stop timer and call king
          this.running = false;
          if (this.timerInfo && this.timerInfo._id) {
            this.stopTimeTracking({ _id: this.timerInfo._id })
              .then(() => {
                this.snackMessage =
                  "Time tracking stopped automatically after shift duration.";
                this.snackbar = true;
              })
              .catch(err => {
                this.snackMessage =
                  "Failed to stop time tracking automatically.";
                this.snackbar = true;
                console.error("Auto stopTimeTracking error", err);
              });
          }
          return;
        }
        //console.log("timerSeconds incremented", this.timerSeconds);
        setTimeout(this.plusSecond, 1000);
      }
    },
    formatSeconds() {
      //console.log("formatSeconds called", this.timerSeconds);
      //console.log("formatSeconds called", this.timerSeconds);
      const hours = Math.floor(this.timerSeconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((this.timerSeconds / 60) % 60)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor(this.timerSeconds % 60)
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
    onFabClick() {
      if (this.needId) {
        this.$router.push({
          name: "agency-need-details",
          query: {
            _id: this.needId
          }
        });
      } else {
        this.$router.push({
          name: "agency-need-feeds"
        });
      }
    },
    checkTrackingTimer() {
      this.findTimer()
        .then(res => {
         // console.log("findTimer response", res);
          this.$store.commit("need/setTimerInfo", {
            ...(res.res || {}),
            shiftHours: res.shiftHours || 0
          });
          this.ifTracking = res.res.status === "Tracking" ? true : false;
          this.needId = res.res?.need_id || null;
          this.shiftHours = res.shiftHours || 0;
          this.timeSlot = res.res?.res || null;
          const startTime = this.convertTZ(res.res.start, this.timezone);
          const currentTime = this.convertTZ("", this.timezone);
          this.timerSeconds = Math.floor((currentTime - startTime) / 1000);
          // Always clear any previous timer before starting a new one
          if (this._timerInterval) {
            clearInterval(this._timerInterval);
            this._timerInterval = null;
          }
          // if res.ifTracking is true, start the timer
          if (this.ifTracking) {
            this.running = true;
            this._timerInterval = setInterval(() => {
              this.timerSeconds++;
              // if not timerinfo, return
              if (!this.timerInfo) return;
              // Check if timer should auto-stop based on shiftHours
              if (
                this.timerInfo.shiftHours > 0 &&
                this.timerSeconds >= this.timerInfo.shiftHours * 60 * 60
              ) {
                this.running = false;
                clearInterval(this._timerInterval);
                this._timerInterval = null;
                if (this.timerInfo && this.timerInfo._id) {
                  this.stopTimeTracking({ _id: this.timerInfo._id })
                    .then(() => {
                      this.snackMessage =
                        "Time tracking stopped automatically after shift duration.";
                      this.snackbar = true;
                    })
                    .catch(err => {
                      this.snackMessage =
                        "Failed to stop time tracking automatically.";
                      this.snackbar = true;
                      console.error("Auto stopTimeTracking error", err);
                    });
                }
              }
            }, 1000);
          } else {
            this.running = false;
            if (this._timerInterval) {
              clearInterval(this._timerInterval);
              this._timerInterval = null;
            }
          }
        })
        .catch(err => {
          console.log("findTimer error", err);
          this.ifTracking = false;
          this.needId = null;
        });
    },
    convertTZ(date, tzString) {
      if (!date) {
        return new Date(
          new Date().toLocaleString("en-US", {
            timeZone: tzString || "America/New_York"
          })
        );
      }
      return new Date(
        (typeof date === "string"
          ? new Date(date)
          : date
        ).toLocaleString("en-US", { timeZone: tzString || "America/New_York" })
      );
    },
    // async getTimerInfo() {
    //   this.loading = true;
    //   try {
    //     // wait until needId is set
    //     if (!this.needId) {
    //       console.warn("Need ID not set, cannot fetch time tracking info");
    //       return;
    //     }
    //     const res = await this.getTimeTracking({ need_id: this.needId });
    //     //console.log("getTimeTracking response", res);
    //     if (!res || !res._id) {
    //       this.running = false;
    //       this.timerSeconds = 0;
    //       this.responses =
    //         res && res.responses
    //           ? res.responses.map((r, i) => ({
    //               ...r,
    //               shift: {
    //                 ...r.shift,
    //                 title: r.shift.title || `Shift ${i + 1}`
    //               }
    //             }))
    //           : [];
    //     } else {
    //       this.timeslot = res;
    //       // store in Vuex store
    //       const startTime = this.convertTZ(this.timerInfo.start, this.timezone);
    //       const currentTime = this.convertTZ("", this.timezone);
    //       this.timerSeconds = Math.floor((currentTime - startTime) / 1000);
    //       this.responses = res.responses.map((r, i) => ({
    //         ...r,
    //         shift: {
    //           ...r.shift,
    //           title: r.shift.title || `Shift ${i + 1}`
    //         }
    //       }));
    //       this.shift = this.timeslot.response_id;
    //       this.memo = this.timeslot.memo;
    //       // Always start timer if tracking is active and not already running
    //       if (this.ifTracking && !this.running) {
    //         this.running = true;
    //         this.plusSecond();
    //       }
    //     }
    //   } catch (error) {
    //     // Prevent error from breaking timer logic
    //     this.running = false;
    //     this.timerSeconds = 0;
    //     this.responses = [];
    //     this.snackMessage =
    //       (error && error.message) || "Failed to load time tracking";
    //     this.snackbar = true;
    //   } finally {
    //     this.loading = false;
    //   }
    // }
  },
  watch: {
    $route(to) {
      const noMenuRoutes = [
        "login",
        "landing",
        "agency-register",
        "business-register",
        "user-register",
        "forgot-password",
        "verification-code",
        "reset-password",
        "facebook-callback",
        "instagram-callback",
        "linkedin-callback",
        "twitter-callback",
        "tiktok-callback"
      ];

      this.showMenu = !noMenuRoutes.includes(to.name);
      if (this.profile && this.profile.type === "Volunteer") {
        this.today = this.convertTZ("", this.timezone);
        this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
        this.checkTrackingTimer();
      }
    },
    profile(newVal) {
      if (newVal?.type) {
        if (this.profile && this.profile.type === "Volunteer") {
          this.checkTrackingTimer();
          this.today = this.convertTZ("", this.timezone);
          this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
          // Start timer automatically if tracking is active
        } else {
          this.ifTracking = false;
          this.needId = null;
        }
      }
    },

    // if need_id is available, fetch timer info
    timerInfo(newVal) {
      //console.log("timerInfo app vue", newVal);
      // if there is change then change the timerSeconds
      if (newVal && newVal.start && newVal.end) {
        const startTime = this.convertTZ(newVal.start, this.timezone);
        const currentTime = this.convertTZ("", this.timezone);
        this.timerSeconds = Math.floor((currentTime - startTime) / 1000);
        this.ifTracking = newVal.status === "Tracking" ? true : false;
        this.needId = newVal.need_id || null;
      }
    }
  },
  mounted() {
    // Wait for profile to be available before starting timer logic
    const waitForProfile = () => {
      if (this.profile && this.profile.type === "Volunteer") {
        this.checkTrackingTimer();
        // Wait for needId to be set by checkTrackingTimer before calling getTimerInfo
        this.today = this.convertTZ("", this.timezone);
        this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
      } else {
        // Retry until profile is available
        setTimeout(waitForProfile, 100);
      }
    };
    waitForProfile();

    const noMenuRoutes = [
      "login",
      "landing",
      "agency-register",
      "business-register",
      "user-register",
      "forgot-password",
      "verification-code",
      "reset-password",
      "facebook-callback",
      "instagram-callback",
      "linkedin-callback",
      "twitter-callback",
      "tiktok-callback",
      null
    ];

    this.showMenu = !noMenuRoutes.includes(this.$route.name);
  },
  computed: {
    ...mapState("auth", { profile: "profile" }),
    ...mapGetters({
      timezone: "usersetting/getTimeZone"
    }),
    ...mapState("need", {
      timerInfo: "timerInfo", // get timerInfo from need.js store
      shifts: "shifts" // get shifts from need.js store
    }),
    formattedTime() {
      const total = this.timerSeconds || 0;
      const hrs = String(Math.floor(total / 3600)).padStart(2, "0");
      const mins = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
      const secs = String(total % 60).padStart(2, "0");
      return `${hrs}:${mins}:${secs}`;
    }
  },
  beforeDestroy() {
    if (this._timerInterval) {
      clearInterval(this._timerInterval);
      this._timerInterval = null;
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Poppins-Bold";
  src: local("Poppins-Bold"),
    url(./assets/fonts/Poppins-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Poppins-Medium";
  src: local("Poppins-Medium"),
    url(./assets/fonts/Poppins-Medium.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins-Regular";
  src: local("Poppins-Regular"),
    url(./assets/fonts/Poppins-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: local("Poppins-SemiBold"),
    url(./assets/fonts/Poppins-SemiBold.ttf) format("truetype");
}
html {
  height: 100%;
}
html #detach-button-host {
  z-index: 10000 !important;
}
.app-bg {
  background: #3b7ca1 !important;
  background-size: cover !important;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.content-view {
  min-height: calc(100vh - 56px);
}
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.v-main__wrap {
  min-height: inherit;
}
.url-button {
  cursor: pointer;
}
.url-button:hover {
  text-decoration: underline;
  color: #0a66c2;
}
.cursor-pointer {
  cursor: pointer;
}

.text-block {
  white-space: pre-line;
  overflow: hidden;
  display: block;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.break-word {
  word-break: break-word;
}
.text-transform-none {
  text-transform: none;
}
.line-height-15 {
  line-height: 15px !important;
}
.text-line-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.primary-color {
  color: #0a5b8a !important;
}
.default-font-color {
  color: #031723;
}
.dark-font-color {
  color: #1e1e1e !important;
}
.dark-gray-color {
  color: #242f36;
}
.dark-blue-color {
  color: #052e45;
}
.white-font-color {
  color: white;
}
.dark-white-color {
  color: #9dbdd0;
}
.blue-font-color {
  color: #5b2cae;
}
.gray-font-color {
  color: #919191;
}
.gray-400 {
  color: #5c5b62;
}
.gray-500 {
  color: #24a39a;
}
.disabled-font-color {
  color: lightgray;
}
.selected-item-color {
  background-color: #55eef3f8;
}
.hover-item-color {
  color: #55eef3f8;
}
.bg-white {
  background-color: white;
}
.bg-primary {
  background-color: #0a5b8a;
}

.w-100 {
  width: 100% !important;
}
.w-50 {
  width: 50% !important;
}
.h-100 {
  height: 100% !important;
}
.h-50 {
  height: 50% !important;
}
.min-width-200 {
  min-width: 200px;
}
.max-width-650 {
  max-width: 650px;
}
.max-width-1500 {
  max-width: 1500px !important;
}
.max-width-2000 {
  max-width: 2000px;
}
.force-height-30 {
  max-height: 30px !important;
  min-height: 30px !important;
}
.force-width-400 {
  max-width: 400px !important;
  min-width: 400px !important;
}
.max-height-0 {
  max-height: 0;
}
.min-height-inherit {
  min-height: inherit;
}
.top-70 {
  top: 70px;
}
.b-0 {
  bottom: 0;
}
.r-0 {
  right: 0;
}

.font-8 {
  font-size: 8px !important;
}
.font-10 {
  font-size: 10px !important;
}
.font-12 {
  font-size: 12px !important;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.font-18 {
  font-size: 18px;
}
.font-20 {
  font-size: 20px !important;
}
.font-22 {
  font-size: 22px !important;
}
.font-24 {
  font-size: 24px !important;
}
.font-28 {
  font-size: 28px !important;
}
.font-30 {
  font-size: 30px !important;
}
.font-40 {
  font-size: 40px !important;
}
.font-50 {
  font-size: 50px !important;
}
.font-64 {
  font-size: 64px !important;
}
.font-bold {
  font-weight: bold;
}
.app-bold-font {
  font-family: "Poppins-SemiBold" !important;
}
.app-medium-font {
  font-family: "Poppins-Medium" !important;
}
.app-regular-font {
  font-family: "Poppins-Regular" !important;
}
.font-normal {
  font-weight: normal;
}

.position-sticky {
  position: sticky;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.justify-between {
  justify-content: space-between !important;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-grow {
  flex-grow: 1;
}
.flex-shrink {
  flex-shrink: 0;
}
.hover-item:hover {
  background-color: #eef3f8;
  cursor: pointer;
}
.hover-scroll:hover {
  overflow-y: auto !important;
}
.hover-scroll::-webkit-scrollbar {
  width: 8px;
  transition-duration: 0.5s;
}

.overflow-hidden {
  overflow: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}

.hover-scroll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px light-grey;
  border-radius: 3px;
}
.hover-scroll::-webkit-scrollbar-thumb {
  background: rgba(240, 160, 0, 0.3);
  border-radius: 3px;
}
.hover-scroll::-webkit-scrollbar-thumb:hover {
  background: #f0a000;
}

#gl-widget-modal {
  display: none;
}

@media (max-width: 600px) {
  .vue-notification-group {
    bottom: 56px !important;
  }
}

.volunteer-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 50px;
  padding: 8px 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  z-index: 9999;
}

.timer-display {
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2b81d6;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.bounce-glow {
  animation: bounceUpDown 1.5s ease-in-out infinite,
    glowPulse 3s ease-in-out infinite;
}

@keyframes bounceUpDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes glowPulse {
  0% {
    box-shadow: 0 0 8px 2px rgba(43, 176, 102, 0.6);
  }
  50% {
    box-shadow: 0 0 18px 5px rgba(103, 231, 161, 0.9);
  }
  100% {
    box-shadow: 0 0 8px 2px rgba(43, 176, 102, 0.6);
  }
}

.volunteer-timer {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2b81d6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 9998;
}

.volunteer-tracker {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.tracker-widget {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 16px;
  padding: 12px 16px 12px 12px;
  box-shadow: 0 8px 24px rgba(43, 176, 102, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(43, 176, 102, 0.3);

    .tracker-btn {
      transform: scale(1.05);
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #2bb066, #4ce487);
  }
}

.tracker-pulse {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background: rgba(43, 176, 102, 0.4);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.tracker-btn {
  margin-right: 12px;
  transition: all 0.3s ease;
  z-index: 2;
}

.tracker-info {
  display: flex;
  flex-direction: column;
}

.tracker-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.tracker-title {
  font-size: 12px;
  font-weight: 600;
  color: #2bb066;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tracker-time {
  font-family: "Roboto Mono", monospace;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 2px;
}

.tracker-subtext {
  font-size: 10px;
  color: #888;
  font-weight: 500;
}

.tracker-progress {
  margin-top: 12px;
  background: white;
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.7;
  }
  70% {
    transform: scale(1.3);
    opacity: 0;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .volunteer-tracker {
    bottom: 16px;
    right: 16px;
  }

  .tracker-widget {
    padding: 10px 14px 10px 10px;
  }

  .tracker-time {
    font-size: 16px;
  }
}

/* Ensure drawer appears above everything */
.group-info-sidebar {
  z-index: 1000 !important;
}

/* Smooth transitions */
.v-navigation-drawer {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Make sure the drawer content scrolls properly */
.drawer-content {
  overflow-y: auto;
  flex: 1;
}
</style>
<template>
  <v-app class="app-bg">
    <navigation v-if="showMenu" />
    <v-main
      class="content-view"
      :style="
        showMenu && $vuetify.breakpoint.xs && $route.name === 'need-map'
          ? 'padding-top:56px;'
          : showMenu &&
            $vuetify.breakpoint.xs &&
            $route.name !== 'mobile-chat-room'
          ? 'padding-top:70px; padding-bottom: 56px'
          : showMenu
          ? 'padding-top:56px;'
          : ''
      "
    >
      <router-view />
      <div
        v-if="
          profile &&
            profile.type === 'Volunteer' &&
            ifTracking &&
            (!timerInfo || timerInfo.status !== 'Completed')
        "
      >
        <div class="volunteer-tracker">
          <!-- Main Floating Widget -->
          <div class="tracker-widget" @click="onFabClick">
            <div class="tracker-pulse"></div>
            <v-btn
              fab
              dark
              large
              class="tracker-btn"
              color="#2BB066"
              elevation="6"
              @click="onFabClick"
            >
              <v-icon x-large>mdi-hand-heart-outline</v-icon>
            </v-btn>

            <div class="tracker-info">
              <div class="tracker-header">
                <v-icon small color="#2BB066" class="mr-1"
                  >mdi-clock-outline</v-icon
                >
                <span class="tracker-title">Active Need</span>
              </div>
              <div class="tracker-time">
                {{ formatSeconds() }}
              </div>
              <div class="tracker-subtext">
                {{ profile.first_name + " " + profile.last_name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-main>
    <notifications group="message" position="bottom left" />
    <bottom-navigation
      v-if="showMenu && $route.name !== 'mobile-chat-room'"
      class="hidden-sm-and-up"
    />
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import dateFormat from "dateformat";
import Navigation from "./components/Navigation.vue";
import BottomNavigation from "./components/BottomNavigation.vue";
import socket from '@/socket';

export default {
  name: "App",
  metaInfo: {
    title: "Default Title",
    titleTemplate: "%s | My Awesome Webapp"
  },
  components: {
    Navigation,
    BottomNavigation
  },

  data() {
    return {
      showMenu: false,
      ifTracking: false,
      needId: null,
      timerSeconds: 0,
      running: false,
      timeslot: null,
      memo: "",
      shift: null,
      responses: [],
      loading: false,
      snackbar: false,
      snackMessage: "",
      today: null,
      startDateStr: "",
      shiftHours: 0,
      timeSlot: null,
      // Renamed to avoid ESLint _ prefix error
      timerIntervalRef: null,
      socketCleanupRef: null
    };
  },

  computed: {
    ...mapState("auth", { profile: "profile" }),
    ...mapGetters({
      timezone: "usersetting/getTimeZone"
    }),
    ...mapState("need", {
      timerInfo: "timerInfo",
      shifts: "shifts"
    }),
    formattedTime() {
      const total = this.timerSeconds || 0;
      const hrs = String(Math.floor(total / 3600)).padStart(2, "0");
      const mins = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
      const secs = String(total % 60).padStart(2, "0");
      return `${hrs}:${mins}:${secs}`;
    }
  },

  watch: {
    $route(to) {
      const noMenuRoutes = [
        "login",
        "landing",
        "agency-register",
        "business-register",
        "user-register",
        "forgot-password",
        "verification-code",
        "reset-password",
        "facebook-callback",
        "instagram-callback",
        "linkedin-callback",
        "twitter-callback",
        "tiktok-callback"
      ];

      this.showMenu = !noMenuRoutes.includes(to.name);
      if (this.profile && this.profile.type === "Volunteer") {
        this.today = this.convertTZ("", this.timezone);
        this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
        this.checkTrackingTimer();
      }
    },

    profile: {
      handler(newVal) {
        if (newVal && newVal._id) {
          // Initialize socket connection
          this.initializeSocket();
          
          if (newVal.type === "Volunteer") {
            this.checkTrackingTimer();
            this.today = this.convertTZ("", this.timezone);
            this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
          } else {
            this.ifTracking = false;
            this.needId = null;
          }
        } else {
          // Disconnect socket when no user
          this.cleanupSocket();
        }
      },
      immediate: true
    },

    timerInfo(newVal) {
      if (newVal && newVal.start && newVal.end) {
        const startTime = this.convertTZ(newVal.start, this.timezone);
        const currentTime = this.convertTZ("", this.timezone);
        this.timerSeconds = Math.floor((currentTime - startTime) / 1000);
        this.ifTracking = newVal.status === "Tracking" ? true : false;
        this.needId = newVal.need_id || null;
      }
    }
  },

  mounted() {
    // Wait for profile to be available before starting timer logic
    const waitForProfile = () => {
      if (this.profile && this.profile._id) {
        // Initialize socket
        this.initializeSocket();
        
        if (this.profile.type === "Volunteer") {
          this.checkTrackingTimer();
          this.today = this.convertTZ("", this.timezone);
          this.startDateStr = dateFormat(this.today, "dddd, mmmm d, yyyy");
        }
      } else {
        // Retry until profile is available
        setTimeout(waitForProfile, 100);
      }
    };
    waitForProfile();

    const noMenuRoutes = [
      "login",
      "landing",
      "agency-register",
      "business-register",
      "user-register",
      "forgot-password",
      "verification-code",
      "reset-password",
      "facebook-callback",
      "instagram-callback",
      "linkedin-callback",
      "twitter-callback",
      "tiktok-callback",
      null
    ];

    this.showMenu = !noMenuRoutes.includes(this.$route.name);

    // Setup socket event listeners
    this.setupSocketListeners();
  },

  beforeDestroy() {
    // Clear timer interval
    if (this.timerIntervalRef) {
      clearInterval(this.timerIntervalRef);
      this.timerIntervalRef = null;
    }
    
    // Clean up socket
    this.cleanupSocket();
  },

  methods: {
    ...mapActions({
      findTimer: "timeslot/findTimer",
      getTimeTracking: "timeslot/getTimeTracking",
      stopTimeTracking: "timeslot/stopTimeTracking"
    }),

    // ========== SOCKET METHODS ==========
    initializeSocket() {
      if (!this.profile || !this.profile._id) return;
      
      // Set socket auth
      socket.auth = {
        token: localStorage.getItem('token') || '',
        userId: this.profile._id,
        userType: this.profile.type || 'User'
      };
      
      // Connect if not already connected
      if (!socket.connected) {
        socket.connect();
      }
      
      // Join user's personal room
      socket.emit('join-chat', { chatId: `user_${this.profile._id}` });
      
      // Send user online status
      socket.emit('user-online', {
        userId: this.profile._id,
        userType: this.profile.type || 'User'
      });
    },

    cleanupSocket() {
      if (this.socketCleanupRef) {
        this.socketCleanupRef();
        this.socketCleanupRef = null;
      }
      
      if (this.profile && this.profile._id) {
        socket.emit('leave-chat', { chatId: `user_${this.profile._id}` });
      }
      
      socket.disconnect();
    },

    setupSocketListeners() {
      // Clean up any existing listeners
      this.cleanupSocketListeners();
      
      // Connection events
      this.connectHandler = () => {
        console.log('Socket connected in App.vue');
        if (this.profile && this.profile._id) {
          socket.emit('user-online', {
            userId: this.profile._id,
            userType: this.profile.type || 'User'
          });
        }
      };
      socket.on('connect', this.connectHandler);
      
      this.disconnectHandler = (reason) => {
        console.log('Socket disconnected:', reason);
      };
      socket.on('disconnect', this.disconnectHandler);
      
      this.connectErrorHandler = (error) => {
        console.error('Socket connection error:', error);
      };
      socket.on('connect_error', this.connectErrorHandler);
      
      // Room joined handler
      this.roomJoinedHandler = (data) => {
        console.log('Room joined:', data);
      };
      socket.on('room-joined', this.roomJoinedHandler);
      
      // User online/offline events
      this.userOnlineHandler = (data) => {
        // Handle user online status if needed
        this.$emit('user-online', data);
      };
      socket.on('user-online', this.userOnlineHandler);
      
      this.userOfflineHandler = (data) => {
        // Handle user offline status if needed
        this.$emit('user-offline', data);
      };
      socket.on('user-offline', this.userOfflineHandler);
      
      // Chat events that need to be handled globally
      this.newMessageHandler = (data) => {
        // If we have a chat module, handle new message
        if (this.$store && this.$store.dispatch) {
          try {
            this.$store.dispatch('chat/receiveMessage', data).catch(() => {});
          } catch (e) {
            console.warn('Could not dispatch receiveMessage:', e);
          }
        }
      };
      socket.on('new-message', this.newMessageHandler);
      
      this.messageDeletedHandler = (data) => {
        // Handle global message deletion
        if (this.$store && this.$store.dispatch) {
          try {
            this.$store.dispatch('chat/handleDelete', data).catch(() => {});
          } catch (e) {
            console.warn('Could not dispatch handleDelete:', e);
          }
        }
      };
      socket.on('message-deleted', this.messageDeletedHandler);
      
      this.messageDeletedForEveryoneHandler = (data) => {
        if (this.$store && this.$store.dispatch) {
          try {
            this.$store.dispatch('chat/handleDeleteForEveryone', data).catch(() => {});
          } catch (e) {
            console.warn('Could not dispatch handleDeleteForEveryone:', e);
          }
        }
      };
      socket.on('message-deleted-for-everyone', this.messageDeletedForEveryoneHandler);
      
      // Store cleanup function
      this.socketCleanupRef = () => {
        socket.off('connect', this.connectHandler);
        socket.off('disconnect', this.disconnectHandler);
        socket.off('connect_error', this.connectErrorHandler);
        socket.off('room-joined', this.roomJoinedHandler);
        socket.off('user-online', this.userOnlineHandler);
        socket.off('user-offline', this.userOfflineHandler);
        socket.off('new-message', this.newMessageHandler);
        socket.off('message-deleted', this.messageDeletedHandler);
        socket.off('message-deleted-for-everyone', this.messageDeletedForEveryoneHandler);
      };
    },
newMessageHandler(data) {
  Promise.resolve(this.$store.dispatch("chat/receiveMessage", data)).catch(() => {});
},
    cleanupSocketListeners() {
      if (this.socketCleanupRef) {
        this.socketCleanupRef();
        this.socketCleanupRef = null;
      }
    },

    // ========== TIMER METHODS ==========
    startCounting() {
      if (this.running) {
        this.running = false;
        if (this.timerIntervalRef) {
          clearInterval(this.timerIntervalRef);
          this.timerIntervalRef = null;
        }
      } else {
        this.running = true;
        this.plusSecond();
      }
    },

    plusSecond() {
      if (this.running) {
        this.timerSeconds++;
        
        if (!this.timerInfo) return;
        
        // Check if timer should auto-stop based on shiftHours
        if (
          this.timerInfo.shiftHours > 0 &&
          this.timerSeconds >= this.timerInfo.shiftHours * 60 * 60
        ) {
          this.running = false;
          if (this.timerIntervalRef) {
            clearInterval(this.timerIntervalRef);
            this.timerIntervalRef = null;
          }
          if (this.timerInfo && this.timerInfo._id) {
            this.stopTimeTracking({ _id: this.timerInfo._id })
              .then(() => {
                this.snackMessage = "Time tracking stopped automatically after shift duration.";
                this.snackbar = true;
              })
              .catch(err => {
                this.snackMessage = "Failed to stop time tracking automatically.";
                this.snackbar = true;
                console.error("Auto stopTimeTracking error", err);
              });
          }
          return;
        }
        
        this.timerIntervalRef = setTimeout(this.plusSecond, 1000);
      }
    },

    formatSeconds() {
      const hours = Math.floor(this.timerSeconds / 3600)
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor((this.timerSeconds / 60) % 60)
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor(this.timerSeconds % 60)
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },

    onFabClick() {
      if (this.needId) {
        this.$router.push({
          name: "agency-need-details",
          query: {
            _id: this.needId
          }
        });
      } else {
        this.$router.push({
          name: "agency-need-feeds"
        });
      }
    },

    checkTrackingTimer() {
      this.findTimer()
        .then(res => {
          this.$store.commit("need/setTimerInfo", {
            ...(res.res || {}),
            shiftHours: res.shiftHours || 0
          });
          this.ifTracking = res.res.status === "Tracking" ? true : false;
          this.needId = res.res?.need_id || null;
          this.shiftHours = res.shiftHours || 0;
          this.timeSlot = res.res?.res || null;
          
          const startTime = this.convertTZ(res.res.start, this.timezone);
          const currentTime = this.convertTZ("", this.timezone);
          this.timerSeconds = Math.floor((currentTime - startTime) / 1000);
          
          // Always clear any previous timer before starting a new one
          if (this.timerIntervalRef) {
            clearInterval(this.timerIntervalRef);
            this.timerIntervalRef = null;
          }
          
          // If tracking is active, start the timer
          if (this.ifTracking) {
            this.running = true;
            this.timerIntervalRef = setInterval(() => {
              this.timerSeconds++;
              
              if (!this.timerInfo) return;
              
              // Check if timer should auto-stop based on shiftHours
              if (
                this.timerInfo.shiftHours > 0 &&
                this.timerSeconds >= this.timerInfo.shiftHours * 60 * 60
              ) {
                this.running = false;
                clearInterval(this.timerIntervalRef);
                this.timerIntervalRef = null;
                if (this.timerInfo && this.timerInfo._id) {
                  this.stopTimeTracking({ _id: this.timerInfo._id })
                    .then(() => {
                      this.snackMessage = "Time tracking stopped automatically after shift duration.";
                      this.snackbar = true;
                    })
                    .catch(err => {
                      this.snackMessage = "Failed to stop time tracking automatically.";
                      this.snackbar = true;
                      console.error("Auto stopTimeTracking error", err);
                    });
                }
              }
            }, 1000);
          } else {
            this.running = false;
            if (this.timerIntervalRef) {
              clearInterval(this.timerIntervalRef);
              this.timerIntervalRef = null;
            }
          }
        })
        .catch(err => {
          console.log("findTimer error", err);
          this.ifTracking = false;
          this.needId = null;
        });
    },

    convertTZ(date, tzString) {
      if (!date) {
        return new Date(
          new Date().toLocaleString("en-US", {
            timeZone: tzString || "America/New_York"
          })
        );
      }
      return new Date(
        (typeof date === "string"
          ? new Date(date)
          : date
        ).toLocaleString("en-US", { timeZone: tzString || "America/New_York" })
      );
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "Poppins-Bold";
  src: local("Poppins-Bold"),
    url(./assets/fonts/Poppins-Bold.ttf) format("truetype");
}

@font-face {
  font-family: "Poppins-Medium";
  src: local("Poppins-Medium"),
    url(./assets/fonts/Poppins-Medium.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins-Regular";
  src: local("Poppins-Regular"),
    url(./assets/fonts/Poppins-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Poppins-SemiBold";
  src: local("Poppins-SemiBold"),
    url(./assets/fonts/Poppins-SemiBold.ttf) format("truetype");
}
html {
  height: 100%;
}
html #detach-button-host {
  z-index: 10000 !important;
}
.app-bg {
  background: #3b7ca1 !important;
  background-size: cover !important;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.content-view {
  min-height: calc(100vh - 56px);
}
.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.v-main__wrap {
  min-height: inherit;
}
.url-button {
  cursor: pointer;
}
.url-button:hover {
  text-decoration: underline;
  color: #0a66c2;
}
.cursor-pointer {
  cursor: pointer;
}

.text-block {
  white-space: pre-line;
  overflow: hidden;
  display: block;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.break-word {
  word-break: break-word;
}
.text-transform-none {
  text-transform: none;
}
.line-height-15 {
  line-height: 15px !important;
}
.text-line-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.primary-color {
  color: #0a5b8a !important;
}
.default-font-color {
  color: #031723;
}
.dark-font-color {
  color: #1e1e1e !important;
}
.dark-gray-color {
  color: #242f36;
}
.dark-blue-color {
  color: #052e45;
}
.white-font-color {
  color: white;
}
.dark-white-color {
  color: #9dbdd0;
}
.blue-font-color {
  color: #5b2cae;
}
.gray-font-color {
  color: #919191;
}
.gray-400 {
  color: #5c5b62;
}
.gray-500 {
  color: #24a39a;
}
.disabled-font-color {
  color: lightgray;
}
.selected-item-color {
  background-color: #55eef3f8;
}
.hover-item-color {
  color: #55eef3f8;
}
.bg-white {
  background-color: white;
}
.bg-primary {
  background-color: #0a5b8a;
}

.w-100 {
  width: 100% !important;
}
.w-50 {
  width: 50% !important;
}
.h-100 {
  height: 100% !important;
}
.h-50 {
  height: 50% !important;
}
.min-width-200 {
  min-width: 200px;
}
.max-width-650 {
  max-width: 650px;
}
.max-width-1500 {
  max-width: 1500px !important;
}
.max-width-2000 {
  max-width: 2000px;
}
.force-height-30 {
  max-height: 30px !important;
  min-height: 30px !important;
}
.force-width-400 {
  max-width: 400px !important;
  min-width: 400px !important;
}
.max-height-0 {
  max-height: 0;
}
.min-height-inherit {
  min-height: inherit;
}
.top-70 {
  top: 70px;
}
.b-0 {
  bottom: 0;
}
.r-0 {
  right: 0;
}

.font-8 {
  font-size: 8px !important;
}
.font-10 {
  font-size: 10px !important;
}
.font-12 {
  font-size: 12px !important;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.font-18 {
  font-size: 18px;
}
.font-20 {
  font-size: 20px !important;
}
.font-22 {
  font-size: 22px !important;
}
.font-24 {
  font-size: 24px !important;
}
.font-28 {
  font-size: 28px !important;
}
.font-30 {
  font-size: 30px !important;
}
.font-40 {
  font-size: 40px !important;
}
.font-50 {
  font-size: 50px !important;
}
.font-64 {
  font-size: 64px !important;
}
.font-bold {
  font-weight: bold;
}
.app-bold-font {
  font-family: "Poppins-SemiBold" !important;
}
.app-medium-font {
  font-family: "Poppins-Medium" !important;
}
.app-regular-font {
  font-family: "Poppins-Regular" !important;
}
.font-normal {
  font-weight: normal;
}

.position-sticky {
  position: sticky;
}
.position-relative {
  position: relative;
}
.position-absolute {
  position: absolute;
}
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.justify-between {
  justify-content: space-between !important;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-grow {
  flex-grow: 1;
}
.flex-shrink {
  flex-shrink: 0;
}
.hover-item:hover {
  background-color: #eef3f8;
  cursor: pointer;
}
.hover-scroll:hover {
  overflow-y: auto !important;
}
.hover-scroll::-webkit-scrollbar {
  width: 8px;
  transition-duration: 0.5s;
}

.overflow-hidden {
  overflow: hidden;
}
.overflow-y-scroll {
  overflow-y: scroll;
}

.hover-scroll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px light-grey;
  border-radius: 3px;
}
.hover-scroll::-webkit-scrollbar-thumb {
  background: rgba(240, 160, 0, 0.3);
  border-radius: 3px;
}
.hover-scroll::-webkit-scrollbar-thumb:hover {
  background: #f0a000;
}

#gl-widget-modal {
  display: none;
}

@media (max-width: 600px) {
  .vue-notification-group {
    bottom: 56px !important;
  }
}

.volunteer-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  background: white;
  border-radius: 50px;
  padding: 8px 12px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  z-index: 9999;
}

.timer-display {
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2b81d6;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.bounce-glow {
  animation: bounceUpDown 1.5s ease-in-out infinite,
    glowPulse 3s ease-in-out infinite;
}

@keyframes bounceUpDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes glowPulse {
  0% {
    box-shadow: 0 0 8px 2px rgba(43, 176, 102, 0.6);
  }
  50% {
    box-shadow: 0 0 18px 5px rgba(103, 231, 161, 0.9);
  }
  100% {
    box-shadow: 0 0 8px 2px rgba(43, 176, 102, 0.6);
  }
}

.volunteer-timer {
  position: fixed;
  bottom: 80px;
  right: 20px;
  background: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  color: #2b81d6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 9998;
}

.volunteer-tracker {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}

.tracker-widget {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 16px;
  padding: 12px 16px 12px 12px;
  box-shadow: 0 8px 24px rgba(43, 176, 102, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(43, 176, 102, 0.3);

    .tracker-btn {
      transform: scale(1.05);
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(to bottom, #2bb066, #4ce487);
  }
}

.tracker-pulse {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background: rgba(43, 176, 102, 0.4);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.tracker-btn {
  margin-right: 12px;
  transition: all 0.3s ease;
  z-index: 2;
}

.tracker-info {
  display: flex;
  flex-direction: column;
}

.tracker-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.tracker-title {
  font-size: 12px;
  font-weight: 600;
  color: #2bb066;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tracker-time {
  font-family: "Roboto Mono", monospace;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 2px;
}

.tracker-subtext {
  font-size: 10px;
  color: #888;
  font-weight: 500;
}

.tracker-progress {
  margin-top: 12px;
  background: white;
  border-radius: 50%;
  padding: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

@keyframes pulse {
  0% {
    transform: scale(0.8);
    opacity: 0.7;
  }
  70% {
    transform: scale(1.3);
    opacity: 0;
  }
  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .volunteer-tracker {
    bottom: 16px;
    right: 16px;
  }

  .tracker-widget {
    padding: 10px 14px 10px 10px;
  }

  .tracker-time {
    font-size: 16px;
  }
}

/* Ensure drawer appears above everything */
.group-info-sidebar {
  z-index: 1000 !important;
}

/* Smooth transitions */
.v-navigation-drawer {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Make sure the drawer content scrolls properly */
.drawer-content {
  overflow-y: auto;
  flex: 1;
}
</style>